export const downloadFile = (fileName: string, fileBlob: Blob): void => {
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(fileBlob, fileName);
  } else {
    const element = document.createElement('a');

    element.setAttribute('href', URL.createObjectURL(fileBlob));

    element.setAttribute('download', fileName);

    element.style.display = 'none';

    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }
};
